(function () {
  'use strict';
  const selection = window.LeavysProductSize;
  const bar = document.querySelector('[data-mobile-buy-bar]');
  if (!selection || !bar) return;
  const state = selection.current();
  if (state.index < 0) return;
  const form = state.form;
  const mainButton = form.querySelector('.add_to_cart');
  if (!mainButton) return;
  const action = bar.querySelector('[data-mobile-buy-action]');
  const price = bar.querySelector('[data-mobile-buy-price]');
  const label = bar.querySelector('[data-mobile-buy-label]');
  const money = new Intl.NumberFormat(document.documentElement.lang || 'en-IE', { style: 'currency', currency: bar.dataset.currency });
  let mainVisible = false;
  function update() {
    const current = selection.current();
    const valid = current.size && current.matched && current.variant.available;
    const busy = valid && (mainButton.disabled || mainButton.classList.contains('disabled'));
    const shown = current.variant || current.product.variants.find((variant) => variant.available) || current.product.variants[0];
    if (shown) price.textContent = money.format(shown.price / 100);
    label.textContent = current.size ? (valid ? bar.dataset.selected : bar.dataset.unavailable).replace('__size__', current.size) : bar.dataset.prompt;
    action.textContent = valid ? mainButton.dataset.label || bar.dataset.add : current.size ? bar.dataset.change : bar.dataset.choose;
    action.disabled = Boolean(busy);
    bar.hidden = mainVisible;
  }
  function chooseSize() {
    const current = selection.current();
    const choices = form.querySelector('.swatch[data-option-index="' + current.index + '"]') || form.querySelectorAll('.single-option-selector')[current.index];
    if (!choices) return;
    choices.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    const checked = choices.querySelector('input:checked');
    const focus = checked && checked.nextElementSibling || choices.querySelector('.swatch-element.available') || choices;
    focus.focus({ preventScroll: true });
  }
  bar.querySelector('[data-mobile-buy-size]').addEventListener('click', chooseSize);
  action.addEventListener('click', () => {
    const current = selection.current();
    if (!current.size || !current.matched || !current.variant.available) return chooseSize();
    if (!mainButton.disabled && !mainButton.classList.contains('disabled')) mainButton.click();
  });
  new IntersectionObserver((entries) => { mainVisible = entries[0].isIntersecting; update(); }, { threshold: 0 }).observe(mainButton);
  new MutationObserver(update).observe(mainButton, { attributes: true, attributeFilter: ['disabled', 'class'] });
  document.addEventListener('leavys:size-change', update);
  update();
})();
